import { Box, Link, Typography, useTheme } from '@mui/material';
import React from 'react';
import {
  EntityName,
  EventType,
  SectionName,
} from 'src/utils/analytics/constants';
import { useImpressionEvent } from 'src/utils/analytics/hooks';
import { FlowCta } from '../flow-cta';
import { JumpPageSectionProps } from '../jump-page-body';

const content = [
  {
    title: '2.8M+',
    body: 'Customers per month shop our credit cards marketplace.',
  },
  { title: ' 1,000+', body: 'Hours spent by experts reviewing cards.' },
  {
    title: '2+ Minutes',
    body: (
      <>
        <FlowCta component={Link}>Complete the questionnaire.</FlowCta> See your
        results. Apply today.
      </>
    ),
  },
];

const DataSection: React.FC<JumpPageSectionProps> = ({
  analytics: { navigationId },
}) => {
  const theme = useTheme();

  const titleStyle = {
    textAlign: 'center',
    marginBottom: 3,
    [theme.breakpoints.down('sm')]: {
      marginTop: 3.5,
      marginBottom: 2,
    },
  };
  const boxStyle = {
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      paddingBottom: 4,
      width: '100%',
      borderRight: 0,
      position: 'relative',
      zIndex: 1,
      ':before': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        height: '1px',
        width: '40%',
        borderBottom: 1,
        margin: 'auto',
      },
      ':last-child': {
        ':before': {
          borderBottom: 0,
        },
      },
    },
    borderRight: 1,
    borderColor: 'neutral.dark',
    display: 'flex',
    flexDirection: 'column',
    paddingY: 3,
    width: '33.3%',
    ':last-child': { borderRight: 0 },
  };

  const { ref } = useImpressionEvent({
    eventType: EventType.ElementImpression,
    navigationId,
    payload: {
      entity_name: EntityName.JumpData,
      section_name: SectionName.JumpData,
      section_position: 5,
    },
  });

  return (
    <Box
      ref={ref}
      display="flex"
      justifyContent="center"
      paddingY={3.5}
      paddingX={0}
      bgcolor="neutral.lightest"
      width="100%"
      sx={{ [theme.breakpoints.down('sm')]: { paddingX: 3 } }}
    >
      <Box
        display="flex"
        flexDirection="row"
        maxWidth="66.6%"
        sx={{
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            maxWidth: '100%',
          },
        }}
      >
        {content.map((data) => (
          <Box key={data.title} sx={boxStyle}>
            <Typography variant="bodyLargeBlack" sx={titleStyle}>
              {data.title}
            </Typography>
            <Typography textAlign="center" variant="text">
              {data.body}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default DataSection;
